import { ethers } from "ethers";
import { getAddresses } from "../../constants";
import { MNTSTokenContract } from "../../abi";
import { clearPendingTxn, fetchPendingTxns } from "./pending-txns-slice";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchAccountSuccess, getBalances } from "./account-slice";
import { JsonRpcProvider, StaticJsonRpcProvider } from "@ethersproject/providers";
import { Networks } from "../../constants/blockchain";
import { warning, success, info, error } from "./messages-slice";
import { messages } from "../../constants/messages";
import { getGasPrice } from "../../helpers/get-gas-price";
import { getLZChainID } from "src/helpers/get-chains";

interface IBridge {
    value: string;
    recipient: string;
    destChainID: number;
    provider: StaticJsonRpcProvider | JsonRpcProvider;
    address: string;
    networkID: Networks;
}

export const bridge_mnts = createAsyncThunk("bridge/send", async ({ value, recipient, destChainID, provider, address, networkID }: IBridge, { dispatch }) => {
    if (!provider) {
        dispatch(warning({ text: messages.please_connect_wallet }));
        return;
    }
    const addresses = getAddresses(networkID);
    const signer = provider.getSigner();
    const mntsContract = new ethers.Contract(addresses.MNTS_ADDRESS, MNTSTokenContract, signer);

    let stakeTx;

    try {
        const gasPrice = await getGasPrice(provider);
        const amount = ethers.utils.parseUnits(value, "ether");
        const lzDestChainID = getLZChainID(destChainID);
        const gasFee = (await mntsContract.estimateSendFee(lzDestChainID, address, amount, false, "0x")).nativeFee;
        stakeTx = await mntsContract.sendFrom(address, lzDestChainID, recipient, amount, address, ethers.constants.AddressZero, "0x", { value: gasFee, gasPrice: gasPrice });
        const text = "Bridge MNTS";
        const pendingTxnType = "bridge_mnts";
        dispatch(fetchPendingTxns({ txnHash: stakeTx.hash, text, type: pendingTxnType }));
        dispatch(success({ text: messages.tx_successfully_send }));
        await stakeTx.wait();
    } catch (err: any) {
        if (err.code === -32603 && err.message.indexOf("ds-math-sub-underflow") >= 0) {
            dispatch(error({ text: "You may be trying to deposit more than your balance! Error code: 32603. Message: ds-math-sub-underflow", error: err }));
        } else {
            dispatch(error({ text: messages.something_wrong, error: err }));
        }
        return;
    } finally {
        if (stakeTx) {
            dispatch(clearPendingTxn(stakeTx.hash));
        }
    }
    dispatch(getBalances({ address, tokens: ["mnts"], networkID, provider }));
    dispatch(info({ text: messages.bridge_initiated }));
    return;
});
